export default "__VITE_ASSET__3e756bfb__"